// v2
(function() {
  let quickAddScriptPromise;
  let quickAddStylePromise;
  function ensureQuickAdd(card) {
    if (!quickAddStylePromise) {
      const styleUrls = [card.dataset.productPageCss, card.dataset.productInfoCss,
        card.dataset.productMediaCss, card.dataset.quickAddCss].filter(Boolean);
      quickAddStylePromise = Promise.all(styleUrls.map(url => {
        const existing = [...document.querySelectorAll('link[rel="stylesheet"]')]
          .find(link => link.href === url);
        if (existing) return Promise.resolve();
        return new Promise((resolve, reject) => {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = url;
          link.onload = resolve;
          link.onerror = () => reject(new Error('Product-page styles could not load.'));
          document.head.append(link);
        });
      }));
    }
    if (!quickAddScriptPromise) {
      quickAddScriptPromise = customElements.get('quick-add-modal') ? Promise.resolve() : new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = card.dataset.quickAddJs;
        script.onload = () => customElements.get('quick-add-modal') ? resolve() : reject(new Error('Quick view could not start.'));
        script.onerror = () => reject(new Error('Quick view could not load.'));
        document.head.append(script);
      }).catch(error => { quickAddScriptPromise = null; throw error; });
    }
    return Promise.all([quickAddStylePromise, quickAddScriptPromise]);
  }
  function initializeProductCards() {
    document.querySelectorAll('.qty-minus:not([data-initialized])').forEach(minus => {
      minus.setAttribute('data-initialized', 'true');
      const input = minus.closest('.card-qty-selector').querySelector('.qty-input');
      minus.addEventListener('click', () => {
        const val = parseInt(input.value, 10);
        const msg = minus.closest('.product-card').querySelector('.qty-max-msg');
        if (val > 1) input.value = val - 1;
        if (msg) msg.style.display = 'none';
      });
    });

    document.querySelectorAll('.qty-plus:not([data-initialized])').forEach(plus => {
      plus.setAttribute('data-initialized', 'true');
      const input = plus.closest('.card-qty-selector').querySelector('.qty-input');
      plus.addEventListener('click', () => {
        const max = parseInt(input.max, 10);
        const current = parseInt(input.value, 10);
        const msg = plus.closest('.card-qty-selector').querySelector('.qty-max-msg');
        if (max && current >= max) {
          if (msg) {
            msg.classList.add('show');
            setTimeout(() => msg.classList.remove('show'), 1500);
          }
        } else {
          input.value = current + 1;
        }
      });
    });

    document.querySelectorAll('.qty-input:not([data-initialized])').forEach(input => {
      input.setAttribute('data-initialized', 'true');
      input.addEventListener('change', () => {
        if (parseInt(input.value, 10) < 1 || isNaN(parseInt(input.value, 10))) input.value = 1;
      });
    });

    document.querySelectorAll('.product-card:not([data-limit-initialized])').forEach(card => {
      card.setAttribute('data-limit-initialized', 'true');
      const titleEl = card.querySelector('.product-card-title');
      if (!titleEl) return;
      const limitMatch = titleEl.textContent.match(/limit\s+(\d+)\s+per/i);
      if (!limitMatch) return;
      const perPersonLimit = parseInt(limitMatch[1], 10);
      const qtyInput = card.querySelector('.qty-input');
      if (!qtyInput) return;
      const inventoryMax = parseInt(qtyInput.max, 10);
      const effectiveMax = inventoryMax ? Math.min(inventoryMax, perPersonLimit) : perPersonLimit;
      qtyInput.max = effectiveMax;
      const msg = card.querySelector('.qty-max-msg');
      if (msg) {
      const limitingFactor = (inventoryMax && inventoryMax < perPersonLimit) ? 'Max' : 'Limit';
      msg.textContent = `${limitingFactor}: ${effectiveMax}`;
}


    });

    document.querySelectorAll('.variant-button:not([data-initialized])').forEach(button => {
      button.setAttribute('data-initialized', 'true');
      button.addEventListener('click', function() {
        if (this.classList.contains('variant-disabled')) return;
        const container = this.closest('.product-card-variants');
        container.querySelectorAll('.variant-button').forEach(btn => btn.classList.remove('variant-selected'));
        this.classList.add('variant-selected');
        const productCard = this.closest('.product-card');
        const addToCartBtn = productCard.querySelector('.custom-atc-btn');
        if (addToCartBtn) addToCartBtn.dataset.variantId = this.dataset.variantId;
        const priceEl = productCard.querySelector('[data-price-display]');
        if (priceEl && this.dataset.price) {
          const comparePrice = this.dataset.comparePrice;
          let html = this.dataset.price;
          if (comparePrice && comparePrice !== 'false' && comparePrice !== '') {
            html += ` <span class="product-card-price-compare">${comparePrice}</span>`;
          }
          priceEl.innerHTML = html;
        }
        const variantId = this.dataset.variantId;
        if (variantId) {
          fetch('/variants/' + variantId + '.js')
            .then(r => r.json())
            .then(variant => {
              const qtyInput = productCard.querySelector('.qty-input');
              if (qtyInput) {
                qtyInput.max = variant.inventory_quantity;
                if (parseInt(qtyInput.value) > variant.inventory_quantity) {
                  qtyInput.value = variant.inventory_quantity;
                }
              }
            });
        }
      });
    });

    document.querySelectorAll('.custom-atc-btn:not([data-initialized])').forEach(button => {
      button.setAttribute('data-initialized', 'true');
      button.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (this.disabled) return;
        if (this.dataset.quickAdd === 'true') {
          const card = this.closest('.product-card');
          try {
            await ensureQuickAdd(card);
            const modal = document.getElementById(card.dataset.quickAddModalId);
            if (!modal || typeof modal.show !== 'function') throw new Error('Quick view is unavailable.');
            modal.style.visibility = '';
            modal.style.position = '';
            modal.style.inset = '';
            modal.show(this);
          } catch (error) {
            console.error(error);
            this.textContent = 'View product options';
            setTimeout(() => { this.textContent = 'Choose options'; }, 2500);
          }
          return;
        }

        let variantId = this.dataset.variantId;
        if (!variantId) {
          const productCard = this.closest('.product-card');
          const selectedVariant = productCard.querySelector('.variant-button.variant-selected');
          if (selectedVariant) variantId = selectedVariant.dataset.variantId;
        }
        if (!variantId) variantId = this.closest('.product-card').dataset.defaultVariantId;
        if (!variantId) { console.error('No variant selected'); return; }

        const qtyEl = this.closest('.product-card').querySelector('.qty-input');
        let quantity = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;

        const cardTitle = this.closest('.product-card').querySelector('.product-card-title')?.textContent || '';
        const limitMatch = cardTitle.match(/limit\s+(\d+)\s+per/i);
        const perPersonLimit = limitMatch ? parseInt(limitMatch[1], 10) : null;

        if (perPersonLimit) {
          const cartCheck = await fetch('/cart.js').then(r => r.json());
          const alreadyInCart = cartCheck.items
            .filter(item => item.variant_id == variantId)
            .reduce((sum, item) => sum + item.quantity, 0);
          if (alreadyInCart >= perPersonLimit) {
            this.textContent = `Limit: ${perPersonLimit} per person`;
            setTimeout(() => { this.textContent = 'Add to Cart'; }, 2000);
            return;
          }
          const remaining = perPersonLimit - alreadyInCart;
          if (quantity > remaining) quantity = remaining;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        })
        .then(response => response.json())
        .then(() => {
          this.textContent = 'Added!';
          setTimeout(() => { this.textContent = 'Add to Cart'; }, 2000);
          fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(r => r.json())
            .then(data => {
              if (data['cart-drawer']) {
                const parsed = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
                const newDrawerInner = parsed.querySelector('.drawer__inner');
                const existingDrawerInner = document.querySelector('cart-drawer .drawer__inner');
                if (newDrawerInner && existingDrawerInner) existingDrawerInner.innerHTML = newDrawerInner.innerHTML;
              }
              if (data['cart-icon-bubble']) {
                const parsed = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
                const newBubble = parsed.querySelector('.cart-count-bubble');
                document.querySelectorAll('.cart-count-bubble').forEach(el => {
                  if (newBubble) el.innerHTML = newBubble.innerHTML;
                  el.classList.remove('hidden');
                });
              }
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) cartDrawer.open();
            });
        })
        .catch(error => console.error('Error adding to cart:', error));
      });
    });
  }

  if (document.readyState !== 'loading') {
    initializeProductCards();
  } else {
    document.addEventListener('DOMContentLoaded', initializeProductCards);
  }

  let mutationTimer;
  new MutationObserver(() => {
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(initializeProductCards, 200);
  }).observe(document.body, { childList: true, subtree: true });

})();

// Filter accordion toggle
function restoreFilterState() {
  const openFilters = JSON.parse(sessionStorage.getItem('openFilters') || '[]');
  openFilters.forEach(function(index) {
    const group = document.querySelector('.filter-group[data-filter-index="' + index + '"]');
    if (!group) return;
    group.classList.add('active');
    const icon = group.querySelector('.filter-icon');
    if (icon) icon.style.transform = 'rotate(180deg)';
  });
}

document.querySelectorAll('.filter-header').forEach(function(btn) {
  btn.addEventListener('click', function() {
    const group = this.closest('.filter-group');
    const index = group.getAttribute('data-filter-index');
    const isOpen = group.classList.contains('active');
    document.querySelectorAll('.filter-group').forEach(function(g) {
      g.classList.remove('active');
      const ic = g.querySelector('.filter-icon');
      if (ic) ic.style.transform = 'rotate(0deg)';
    });
    if (!isOpen) {
      group.classList.add('active');
      const icon = this.querySelector('.filter-icon');
      if (icon) icon.style.transform = 'rotate(180deg)';
      sessionStorage.setItem('openFilters', JSON.stringify([index]));
    } else {
      sessionStorage.setItem('openFilters', JSON.stringify([]));
    }
  });
});

document.addEventListener('DOMContentLoaded', restoreFilterState);

// Filter form - apply filters on checkbox change (custom block only)
document.addEventListener('change', function(e) {
  if (!e.target.closest('#search-filters-form[data-custom-filters]')) return;
  if (e.target.id === 'search-sort' || e.target.classList.contains('search-sort-select')) return;

  e.stopPropagation();
  e.stopImmediatePropagation();

  const form = document.getElementById('search-filters-form');
  const formData = new FormData(form);
  const params = new URLSearchParams(formData);

  // Preserve the search query
  const currentParams = new URLSearchParams(window.location.search);
  if (currentParams.get('q')) {
    params.set('q', currentParams.get('q'));
  }

  const sortSelect = document.getElementById('search-sort');
  if (sortSelect && sortSelect.value) {
    params.set('sort_by', sortSelect.value);
  }

  const clearBtn = document.getElementById('clear-filters-btn');
  if (clearBtn) {
    clearBtn.style.display = params.toString() ? 'block' : 'none';
  }

  window.location.href = window.location.pathname + '?' + params.toString();
});



// Clear all filters
document.addEventListener('click', function(e) {
  if (!e.target.closest('#clear-filters-btn')) return;
  window.location.href = window.location.pathname;
});

// Show clear button on load if filters active
document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  const clearBtn = document.getElementById('clear-filters-btn');
  if (!clearBtn) return;
  const hasActiveFilters = [...urlParams.keys()].some(key => key !== 'sort_by');
  if (hasActiveFilters) clearBtn.style.display = 'block';
});


// Sort dropdown handler for native collection/search pages
(function() {
  function initSortDropdown() {
    const sortSelect = document.getElementById('search-sort');
    if (!sortSelect || sortSelect.dataset.sortInitialized) return;
    sortSelect.dataset.sortInitialized = 'true';
    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  if (document.readyState !== 'loading') {
    initSortDropdown();
  } else {
    document.addEventListener('DOMContentLoaded', initSortDropdown);
  }
})();


// Mobile filter toggle
const mobileToggle = document.getElementById('mobile-filter-toggle');
const filtersInner = document.getElementById('search-filters-inner');

if (mobileToggle && filtersInner) {
  mobileToggle.addEventListener('click', function() {
    const isOpen = filtersInner.classList.contains('mobile-open');
    filtersInner.classList.toggle('mobile-open', !isOpen);
    mobileToggle.classList.toggle('open', !isOpen);
    mobileToggle.setAttribute('aria-expanded', String(!isOpen));
  });
}
